import { SettingsMenuLayout } from '../../../Layouts/SettingsMenuLayout';
import BaseUISystem from '../BaseUISystem';
import { GameScene } from '../../../State/Game/GameScene';
import { PopupID } from '../../../State/UI/PopupID';
import BaseMenu from 'System/UI/Menu/BaseMenu';
import { Layout } from 'Utility/layout/createLayout';
import RelativePositionComponent from 'Component/Render/RelativePosition';
import Point from 'Utility/Point';
import { applyDefaultButtonAnimation } from 'System/UI/UIHelper';
import { GameObjectEvent } from 'GameObject/GameObject';
import Game from 'Game';
import { UIActions } from 'State/UI/UIActions';
import { PlayerActions } from 'State/Player/PlayerActions';
import { AudioStreamType } from 'System/Audio/AudioSystem';
import IPlayerSettingsData from 'Player/PlayerProperty/Settings/IPlayerSettingsData';
import TextComponent from 'Component/Render/Text';
import SpriteComponent from "Component/Render/Sprite";
import Renderable from "Component/Renderable";
import {GameActions} from "State/Game/GameActions";
import {LevelStatus} from "State/Level/LevelStatus";

interface ISettingsMenuShowParams {
    gameScene: GameScene;
    levelNumber?: number;
}

export class SettingsPopup extends BaseMenu {
    private layout: any;

    constructor(uiSystem: BaseUISystem) {
        super(PopupID.SETTINGS_MENU, uiSystem, false);
    }

    public onShow(params: ISettingsMenuShowParams): void {
        super.onShow(params);
        this.layout = new SettingsMenuLayout();
        this.layout.root.addComponent(RelativePositionComponent);
        this.layout.root.getComponent(RelativePositionComponent).relativePosition = new Point(0.5, 0.5);
        this.element.addChild(this.layout.root);

        const { close_btn, return_btn, exit_level_btn, music_btn, sound_btn, version_txt, user_id_txt, user_id_heading } = this.layout;
        [close_btn, return_btn, exit_level_btn, music_btn, sound_btn].forEach(o => applyDefaultButtonAnimation(o));
        close_btn.once(GameObjectEvent.SELECTED, () => UIActions.hidePopup(this.name));
        return_btn.once(GameObjectEvent.SELECTED, () => UIActions.hidePopup(this.name));
        exit_level_btn.once(GameObjectEvent.SELECTED, () => GameActions.endLevel({
            status: LevelStatus.EXITING,
            firstComplete: false
        }));
        music_btn.on(GameObjectEvent.SELECTED, () => this.toggleAudio(AudioStreamType.MUSIC));
        sound_btn.on(GameObjectEvent.SELECTED, () => this.toggleAudio(AudioStreamType.SFX));

        // disabled player id and version for Samsung/azerion
        version_txt.getComponent(TextComponent).text = "";// += `: ${Game.config.release}`;
        user_id_txt.getComponent(TextComponent).text = ""; //Game.sdk.getUserId();
        this.setAudio();

        // Handle Return/Quit level button
        if (Game.store.getState().activeScene.result === GameScene.WORLD) {
            return_btn.getComponent(Renderable).container.visible = true;
            exit_level_btn.getComponent(Renderable).container.visible = false;
        } else {
            return_btn.getComponent(Renderable).container.visible = false;
            exit_level_btn.getComponent(Renderable).container.visible = true;
        }
    }

    private setAudio():void {
        const { playerState } = Game.store.getState();

        const musicEnabled: boolean = playerState.settings[AudioStreamType.MUSIC];
        const sfxEnabled: boolean = playerState.settings[AudioStreamType.SFX];

        this.layout.music_txt.getComponent(TextComponent).text = Game.locale.getText(musicEnabled ? 'On' : 'Off');
        this.layout.sound_txt.getComponent(TextComponent).text = Game.locale.getText(sfxEnabled ? 'On' : 'Off');
        this.layout.music_btn.getComponent(SpriteComponent).texture = `audiomusic_${Number(musicEnabled)}`;
        this.layout.sound_btn.getComponent(SpriteComponent).texture = `audiosfx_${Number(sfxEnabled)}`;
    }

    private toggleAudio = (type: AudioStreamType): void => {
        const enabled: boolean = !Game.store.getState().playerState.settings[type as keyof IPlayerSettingsData];
        PlayerActions.setVolume({ type, enabled });

        this.setAudio();
    };
}
